export enum InfoSectionPanelKey {
  PROGRAM_DETAILS = "program_details",
  SUBMISSION = "submission",
  VULN_DETAILS = "vulnerability_details",
}

export enum VulnSource {
  BUGBOUNTY = "bugbounty",
  PENTEST = "pentest",
  AUTO_SCAN = "auto_scan",
  DATA_LEAK = "data_leak",
}
